<template>
    <div>
        <div>
            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;"><b>-产品类别列表</b></p>

                <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                    <el-button round type="primary" @click="openTypeDialog">新增类别</el-button>
                </p>
            </div>

            <el-table :data="baseProductTypeList" style="width: 100%" tooltip-effect="dark">
                <el-table-column type="index" width="20" fixed>
                </el-table-column>

                <el-table-column prop="productTypeName" label="类别名称" min-width="40%" fixed>
                </el-table-column>

                <el-table-column prop="maker" label="创建人" min-width="13%">
                </el-table-column>
                <el-table-column prop="createdTime" label="创建时间" width="110">
                </el-table-column>


                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <!-- <el-button @click="processHandleClick(scope.row)" type="success" round size="small">
                            编辑
                        </el-button> -->
                        <el-button @click="deleteClick(scope.row)" type="danger" round size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-dialog title="类别详情" :visible.sync="productTypeDlgVisible" width="50%">
                <el-form :inline="true" :model="productTypeForm">
                    <el-form-item label="类别名称" required :label-width="formLabelWidth">
                        <el-input v-model="productTypeForm.productTypeName" autocomplete="off" style="width:400px"
                            :disabled="processNameDisable"></el-input>
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="productTypeDlgVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addBaseProductType">保 存</el-button>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
import Sortable from 'sortablejs'

export default {
    name: "ProductTypeBase",
    data() {
        return {
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),

            formLabelWidth: '120px',

            productTypeDlgVisible: false,
            productTypeForm: {
                id: '',
                productTypeName: '',
            },
            baseProductTypeList: []
        }
    },
    methods: {
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removeBaseProductType(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        removeBaseProductType(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/base/product/type/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAllBaseProductType()
            })
        },
        //行拖拽
        rowDrop() {
            const tbodys = document.querySelectorAll('.el-table__body tbody')//[8]
            // console.log(tbodys)

            const tbody = document.body.querySelector('.el-table__body tbody')
            // console.log('tbody')
            // console.log(tbody)

            const _this = this
            // console.log('_this')
            // console.log(_this)

            Sortable.create(tbody, {
                onEnd({ newIndex, oldIndex }) {
                    if (newIndex == oldIndex) return

                    _this.productList.splice(newIndex, 0, _this.productList.splice(oldIndex, 1)[0])

                    var newArray = _this.productList.slice(0)
                    // console.log('newArray')
                    // console.log(newArray)

                    _this.productList = []

                    _this.$nextTick(function () {
                        _this.productList = newArray

                        this.sort(newArray)
                    })

                }
            })

        },
        sort(val) {
            // console.log('sort()')
            const baseBOMInfoVOList = []

            this.$axios({
                method: "post",
                url: "/shiro/base/bom/sort",
                data: {
                    baseBOMInfoVOList: val,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

            })
        },
        openTypeDialog() {

            this.productTypeForm.id = ''
            this.productTypeForm.productTypeName = ''

            this.productTypeDlgVisible = true
        },
        addBaseProductType() {

            const form = new FormData()

            form.append('id', this.productTypeForm.id)

            form.append('productTypeName', this.productTypeForm.productTypeName)
            form.append('maker', this.userId)
            form.append('companyId', this.companyId)

            this.$axios({
                method: "post",
                url: "/shiro/base/product/type/add",
                data: form,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.productTypeDlgVisible = false

                this.getAllBaseProductType()
            })
        },
        getAllBaseProductType() {
            this.$axios({
                method: "post",
                url: "/shiro/base/product/type/getAll",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.baseProductTypeList = data.data
                for (let i in this.baseProductTypeList) {
                    this.baseProductTypeList[i].createdTime = this.$moment(this.baseProductTypeList[i].createdTime).format("YYYY-MM-DD")
                }
            })
        },
    },
    mounted() {
        this.setDefaultPath('/productTypeBase')

        // 阻止默认行为
        document.body.ondrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };
        this.rowDrop()//行拖拽

        this.getAllBaseProductType()
    },
    updated() {

    }
}
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}
</style>